import React from "react"
import styled from "styled-components"
import { Popover as RadixPopover } from "radix-ui"

interface Props {
  content: React.ReactNode
  children: React.ReactNode
}

const StyledPopoverContent = styled(RadixPopover.Content)`
  background-color: ${({ theme }) => theme.colors["Background/Primary"]};
  color: ${({ theme }) => theme.colors["Content/Primary"]};
  border: solid 1px ${({ theme }) => theme.colors["Border/Primary"]};
  padding: 8px;
  border-radius: 8px;
  outline: none;
  z-index: 1000;
`

const StyledPopoverTrigger = styled(RadixPopover.Trigger)`
  display: inline-block;
  cursor: pointer;
`

export const Popover: React.FC<Props> = ({ content, children }) => (
  <RadixPopover.Root>
    <StyledPopoverTrigger asChild>
      <div>{children}</div>
    </StyledPopoverTrigger>
    <StyledPopoverContent>
      <RadixPopover.Arrow />
      {content}
    </StyledPopoverContent>
  </RadixPopover.Root>
)
